import * as DocumentTypes from './doc-admin.actions';
import * as DocumentTypesDetail from './doc-admin-details.actions';

export const DocumentTypeActions = {
    DocumentTypes,
    DocumentTypesDetail
};
